import { render, staticRenderFns } from "./InvestorDetails.vue?vue&type=template&id=68804097&"
import script from "./InvestorDetails.vue?vue&type=script&lang=js&"
export * from "./InvestorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports